import { ReactNode } from 'react';
import { Accordion as BootstrapAccordion } from 'react-bootstrap';
import { AccordionEventKey } from 'react-bootstrap/esm/AccordionContext';

export interface AccordionProps {
    children: ReactNode;
    defaultActiveKey?: AccordionEventKey;

    /** Use this only if you need direct control over expand/collapse functionality. */
    activeKey?: AccordionEventKey;
    /** Use this only if you need direct control over expand/collapse functionality. */
    onSelect?: (eventKey: AccordionEventKey) => void;
}

export const Accordion = (props: AccordionProps) => {
    return (
        <BootstrapAccordion defaultActiveKey={props.defaultActiveKey} activeKey={props.activeKey} onSelect={props.onSelect}>
            {props.children}
        </BootstrapAccordion>
    );
};
